import {
  mobileConfigurationByIdEndpoint,
  userGroupsEndpoint,
  userTypesEndpoint,
  zipEndpoint
} from "../endpoints";

export const EditEndpoint = {
  getConfiguration: mobileConfigurationByIdEndpoint,
  updateConfiguration: mobileConfigurationByIdEndpoint,
  uploadZip: zipEndpoint,
  userTypes: userTypesEndpoint,
  userGroups: userGroupsEndpoint
};
